import api from 'api/api'
import { toast } from "react-toastify"

import { API_URL } from 'constants/index'

export const GET_ALL_USERS = "[USERS] GET ALL USERS"

export const GET_USERS = "[USERS] GET USERS"

export const CRUD_USER = "[USERS] CRUD USER"

export const VALIDATE_USER_TO_MODIFY_PRICES = "[USERS] VALIDATE USER TO MODIFY PRICES"

export const GET_USER_SERIES = "[USERS] GET USER SERIES"

export const CRUD_USER_SERIE = "[USERS] CRUD USER SERIE"

export function getAllUsers() {
  const request = api.get(`/usuario/todos`)
  return (dispatch) =>
    request.then((response) => {
      dispatch({ type: GET_ALL_USERS, payload: response.data.detalles })
    }).catch((err) => {
      toast.error("Error al obtener los usuarios")
      console.log(err)
    })
}

export function getUsers(
  { page = 1, pageSize = 10, branchId = '', role = '', status = '', search = '' }
) {
  const request = api.get(`/usuario/registros`, {
    params: {
      page,
      por_pagina: pageSize,
      sucursal_id: branchId,
      rol: role,
      estado: status,
      busqueda: search,
    }
  })
  return (dispatch) => {
    dispatch({ type: GET_USERS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_USERS, payload: { loading: false, ...response.data } })
    }).catch((error) => {
      dispatch({ type: GET_USERS, payload: { loading: false } })
      console.log(error);
    })
  }
}

export function saveUser(form) {
  const request = api.post(`/rusuario`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_USER, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_USER, payload: { loading: false, crud: true } })
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      return setTimeout(() => {
        dispatch({ type: CRUD_USER, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((err) => {
      dispatch({ type: CRUD_USER, payload: { loading: false, crud: false } })
      toast.error("Error inesperado. No se pudo guardar el usuario")
      console.log(err)
    })
  }
}

export function deleteUser(form) {
  const request = api.post(`/eusuario`, form)
  return (dispatch) => {
    toast.info("Eliminando usuario...", { toastId: "deleteUser", autoClose: false })
    dispatch({ type: CRUD_USER, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_USER, payload: { loading: false, crud: true } })
        toast.success(response.data.message, { toastId: "deleteUser", autoClose: 5000 })
      } else {
        toast.error(response.data.message, { toastId: "deleteUser", autoClose: 5000 })
      }
      return setTimeout(() => {
        dispatch({ type: CRUD_USER, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((err) => {
      dispatch({ type: CRUD_USER, payload: { loading: false, crud: false } })
      toast.error("Error inesperado. No se pudo eliminar al usuario", { toastId: "deleteUser", autoClose: 5000 })
      console.log(err)
    })
  }
}

export function updateUserStatus(form) {
  const request = api.post(`/cusuario`, form)
  return (dispatch) => {
    toast.info("Actualizando estado...", { toastId: "updateUserStatus", autoClose: false })
    dispatch({ type: CRUD_USER, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_USER, payload: { loading: false, crud: true } })
        toast.success(response.data.message, { toastId: "updateUserStatus", autoClose: 5000 })
      } else {
        toast.error(response.data.message, { toastId: "updateUserStatus", autoClose: 5000 })
      }
      return setTimeout(() => {
        dispatch({ type: CRUD_USER, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((err) => {
      dispatch({ type: CRUD_USER, payload: { loading: false, crud: false } })
      toast.error("Error inesperado. No se pudo actualizar el estado del usuario", { toastId: "updateUserStatus", autoClose: 5000 })
      console.log(err)
    })
  }
}

export function validateUserToModifyPrices(form) {
  const request = api.post(`/usuario/validar-usuario-para-modificar-precios`, form)
  return (dispatch) => {
    dispatch({ type: VALIDATE_USER_TO_MODIFY_PRICES, payload: 'loading' })
    request.then((response) => {
      if (parseInt(response.data.status) === 400) {
        dispatch({ type: VALIDATE_USER_TO_MODIFY_PRICES, payload: 'rejected' })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: VALIDATE_USER_TO_MODIFY_PRICES, payload: 'success' })
      toast.success(response.data.message)
      setTimeout(() => {
        dispatch({ type: VALIDATE_USER_TO_MODIFY_PRICES, payload: 'init' })
      }, 50)
    }).catch((err) => {
      dispatch({ type: VALIDATE_USER_TO_MODIFY_PRICES, payload: 'error' })
      toast.error("Error en la solicitud al servidor")
      console.log(err)
    })
  }
}

export function getUserSeries({ userId = 0 }) {
  const request = api.get(`/serie-usuario?idusuario=${userId}`)
  return (dispatch) => {
    dispatch({ type: GET_USER_SERIES, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: GET_USER_SERIES, payload: { loading: false, data: response.data.detalles } })
      } else {
        dispatch({ type: GET_USER_SERIES, payload: { loading: false, data: null } })
      }
      setTimeout(() => {
        dispatch({ type: GET_USER_SERIES, payload: { loading: false, data: null } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: GET_USER_SERIES, payload: { loading: false, data: null } })
      toast.error("Error al obtener las series del usuario")
      console.log(error)
    })
  }
}

export function saveUserSerie(form) {
  const request = api.post(`/serie-usuario/guardar`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_USER_SERIE, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_USER_SERIE, payload: { loading: false, crud: true } })
      } else {
        toast.error(response.data.message)
      }
      return setTimeout(() => {
        dispatch({ type: CRUD_USER_SERIE, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((err) => {
      dispatch({ type: CRUD_USER_SERIE, payload: { loading: false, crud: false } })
      toast.error("Error inesperado. No se pudo asignar la serie al usuario")
      console.log(err)
    })
  }
}

export function deleteUserSerie(form) {
  const request = api.post(`/serie-usuario/eliminar`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_USER_SERIE, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_USER_SERIE, payload: { loading: false, crud: true } })
      } else {
        toast.error(response.data.message)
      }
      return setTimeout(() => {
        dispatch({ type: CRUD_USER_SERIE, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((err) => {
      dispatch({ type: CRUD_USER_SERIE, payload: { loading: false, crud: false } })
      toast.error("Error inesperado. No se pudo eliminar la serie del usuario")
      console.log(err)
    })
  }
}


